import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { ModalOfferComponent } from '../modal/modal.component';

@Component({
  selector: 'details-offer',
  standalone: true,
  imports: [
    TranslateModule,
    DatePipe
  ],
  templateUrl: './offer.component.html',
  styleUrl: './offer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class OfferComponent {
    public offer: InputSignal<any> = input.required<any>();
    public tools = inject(ToolsService);
    public translate = inject(TranslateService);
    private modalController = inject(ModalController);

    async showOffer(){
      const modal = await this.modalController.create({
        component: ModalOfferComponent,
        cssClass: ['offerModal', 'ion-disable-focus-trap'],
        componentProps: { offer: this.offer }
      });
      await modal.present();
    }
}